import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MiniErrors } from "../../components/MiniErrors/styles";
import { Link, useHistory } from "react-router-dom";
import { Container, SubContainer, Title } from "../Login/styles";
import { FormSignUp } from "./styles";
import { Label } from "../Login/styles";
import { Input, SelectInput } from "../../components/Input/styles";
import { Button } from "../../components/Button/styles";
import api from "../../services/api";

function SignUp() {
  const history = useHistory();
  const formSchema = yup.object().shape({
    name: yup.string().required("Nome obrigatório").max(20),
    email: yup
      .string()
      .required("E-mail obrigatório")
      .email("Formato de E-mail incorreto"),
    password: yup
      .string()
      .required("Senha obrigatória")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Precisa conter 8 caracteres, letras, números e um caractere especial"
      ),
    passwordConf: yup
      .string()
      .oneOf([yup.ref("password"), null], "As senhas devem ser iguais"),
    bio: yup.string().max(200).required("Bio obrigatória"),
    contact: yup.string().required("Contato obrigatório"),
    course_module: yup
      .string()
      .matches(/^((?!default).)*$/s, "Campo obrigatório"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const onSubmitFunction = (data) => {
    const { email, password, name, bio, contact, course_module } = data;
    const newUser = {
      email,
      password,
      name,
      bio,
      contact,
      course_module,
    };
    api
      .post("/users", newUser)
      .then((res) => {
        history.push("/");
        console.log(res);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Container>
        <SubContainer heigth="750px">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "15px",
            }}
          >
            <Title color="#FF577F" fontSize="30px">
              Kenzie Hub
            </Title>
            <Link
              to="/"
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#212529",
                borderRadius: "10px",
                padding: "10px",
                fontFamily: "Inter",
              }}
            >
              Voltar
            </Link>
          </div>
          <FormSignUp onSubmit={handleSubmit(onSubmitFunction)}>
            <Title color="white" fontSize="17px">
              Crie sua conta
            </Title>
            <Title color="#868E96" fontSize="12px">
              Rápido e grátis, vamos nessa
            </Title>
            <div>
              <Label>
                Nome{" "}
                {errors.name && <MiniErrors> {errors.name.message}</MiniErrors>}
              </Label>
              <Input
                name="name"
                {...register("name")}
                placeholder="Digite aqui seu nome"
              />
            </div>
            <div>
              <Label>
                E-mail{" "}
                {errors.email && (
                  <MiniErrors> {errors.email.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="email"
                {...register("email")}
                placeholder="Digite aqui seu email"
              />
            </div>
            <div>
              <Label htmlFor="password">
                Senha{" "}
                {errors.password && (
                  <MiniErrors> {errors.password.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="password"
                {...register("password")}
                placeholder="Digite aqui sua senha"
              />
            </div>
            <div>
              <Label htmlFor="passwordConf">
                Confirmar Senha{" "}
                {errors.passwordConf && (
                  <MiniErrors> {errors.passwordConf.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="passwordConf"
                {...register("passwordConf")}
                placeholder="Confirme sua senha"
              />
            </div>
            <div>
              <Label htmlFor="bio">
                Bio{" "}
                {errors.bio && <MiniErrors> {errors.bio.message}</MiniErrors>}
              </Label>
              <Input
                name="bio"
                {...register("bio")}
                placeholder="Fale sobre você"
              />
            </div>
            <div>
              <Label htmlFor="contact">
                Contato{" "}
                {errors.contact && (
                  <MiniErrors> {errors.contact.message}</MiniErrors>
                )}
              </Label>
              <Input
                name="contact"
                {...register("contact")}
                placeholder="Opção de contato"
              />
            </div>
            <div>
              <Label htmlFor="selectModule">
                Selecionar Módulo{" "}
                {errors.course_module && (
                  <MiniErrors> {errors.course_module.message}</MiniErrors>
                )}{" "}
              </Label>
              <SelectInput
                defaultValue="default"
                {...register("course_module")}
              >
                <option value="default" disabled>
                  Selecionar Módulo
                </option>
                <option value="Primeiro Módulo (Frontend básico)">M1</option>
                <option value="Segundo Módulo (Frontend avançado)">M2</option>
                <option value="Terceiro Módulo (Frontend avançado)">M3</option>
                <option value="Quarto Módulo (Backend básico)">M4</option>
              </SelectInput>
            </div>
            <Button type="submit" backgroundColor="#59323F" fontSize="20px">
              Cadastrar
            </Button>
          </FormSignUp>
        </SubContainer>
      </Container>
    </>
  );
}
export default SignUp;
